import React, { Fragment, useContext, useState } from 'react';
import { getFullImageUrl, centsToDollars } from '../../../utils';
import store from '../../../../store';
import { TTMenuItem } from '../../../../interfaces/menuItem';
import PillLabel from '../../../../components/PillLabel';
import { Transition } from '@headlessui/react';
import { TTMenu } from '../../../../interfaces/menus';
import { CheckoutContext } from '../../../Providers/CheckoutContext';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../rootReducer';

type Props = {
  menuItem: TTMenuItem;
  onClick: () => void;
  menu?: TTMenu;
};

const MenuItemCard: React.FC<Props> = ({ menuItem, onClick, menu }) => {
  const [loading, setLoading] = useState(true);
  const currentCheckout = useContext(CheckoutContext);

  const qrCode = useSelector<RootState, string | null>(
    state => state.cart.qr_code,
  );

  const qrCodeOrdering = useSelector<RootState, { [key: string]: boolean }>(
    state => state.restaurant.qr_ordering_enabled,
  );

  return (
    <li key={menuItem.id} onClick={onClick} className={'w-full h-full'}>
      <Transition
        appear={true}
        show={true}
        as={'div'}
        key={menuItem.id.toString()}
        enter="transition-opacity duration-75"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition-opacity duration-150"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="w-full h-full rounded transition ease-in-out delay-50  hover:-translate-y-1 hover:scale-105 duration-300 cursor-pointer ">
          <div className="flex-grow flex flex-row  bg-primary/10  p-4 items-between rounded-lg shadow-lg justify-between">
            <div className="flex-grow flex flex-col justify-between leading-normal">
              <div className="mb-2">
                <div className="text-on-surface font-bold text-sm mb-2 mr-1">
                  {menuItem.name}
                </div>
                <div className="max-h-20">
                  <p className="text-on-surface text-xs line-clamp-4 mr-1 whitespace-pre-line">
                    {menuItem.description}
                  </p>
                </div>
              </div>
              <div className="flex flex-row justify-left items-center  space-x-1 space-y-0">
                <div>
                  <PillLabel
                    color={
                      menuItem.out_of_stock
                        ? 'bg-error-container'
                        : 'bg-primary'
                    }
                    label={`${
                      store.getState().restaurant.profile.is_payment_live
                        ? menuItem?.out_of_stock
                          ? 'Out of Stock'
                          : menuItem.product_type === 'subscription'
                          ? 'Click to View'
                          : store.getState().cart?.qr_code === null &&
                            store.getState().restaurant?.profile
                              ?.restaurant_id === 6
                          ? 'Click to View'
                          : qrCode !== null && !qrCodeOrdering[qrCode]
                          ? 'Click to View'
                          : 'Click to Add'
                        : 'Click to View'
                    }`}
                    text_color={
                      menuItem.out_of_stock ? 'text-error' : 'text-on-primary'
                    }
                  />
                </div>
                {menuItem.price && menuItem.price !== 0 ? (
                  <div className="">
                    <PillLabel
                      color="bg-tertiary-container"
                      text_color="text-on-tertiary-container"
                      label={centsToDollars(menuItem.price)}
                    />
                  </div>
                ) : (
                  <></>
                )}
                {menuItem.product_type === 'subscription' ? (
                  <div className="rounded-full bg-tertiary-container text-on-tertiary-container px-2 text-md font-semibold flex">
                    Subscription
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
            {menuItem.image_url !== null &&
              !RegExp(
                `^(https:\/\/d2b8t2l9x5xm7h.cloudfront.net\/public\/[0-9]*\/100.jpg).*`,
              ).test(menuItem.image_url) && (
                <img
                  loading="lazy"
                  className={`  flex w-32 h-32 shrink-0 rounded-lg object-cover `}
                  src={getFullImageUrl(
                    menu?.is_shared
                      ? menu?.restaurant_id
                      : store.getState().restaurant.profile.restaurant_id,
                    menuItem.image_url,
                  )}
                  alt={menuItem.name + "'s photo"}
                />
              )}
          </div>
        </div>
      </Transition>
    </li>
  );
};

export default MenuItemCard;
